import { render } from "./Test.vue?vue&type=template&id=0b0ca0e7&bindings={\"people\":\"data\",\"onSubmit\":\"options\",\"setSelected\":\"options\"}"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"
script.render = render

export default script